module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>\n  <input name="import" type="checkbox" value="'+
((__t=( id ))==null?'':_.escape(__t))+
'" class="import"\n    ';
 if (selected) { 
__p+='checked="checked" ';
 } 
__p+=' />\n</td>\n<td>'+
((__t=( last_name ))==null?'':_.escape(__t))+
', '+
((__t=( first_name ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( school_year ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( school_reg ))==null?'':_.escape(__t))+
'</td>\n<td class="match grid3">\n  <select name="contact" class="contact"></select>\n</td>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./parentpay/templates/contact/row.html
// module id = 227
// module chunks = 0